var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.isPC ? 'floatten-pc' : 'floatten-mobile'}},[_c('div',{class:_vm.containerClass},[_c('BubbleIcon',{staticClass:"msg-bubble-icon",on:{"click":_vm.openHelp}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }